// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"3759d597","160":"8428ad1f","208":"729f42c0","293":"22d264d8","516":"1b508807","519":"de06281a","906":"79a92724","917":"b16bf6a0","946":"0bd944d6"}[chunkId] + ".chunk.js";
};